import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import SupportTicketDashboard from "@/components/SupportTicketDashboard";

const SupportTickets = () => {
  useEffect(() => {
    document.title = "My Support Tickets - Ascendry";
  }, []);

  return (
    <div className="min-h-screen bg-gradient-dark">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {/* Back to Home Button */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center space-x-2 text-muted-foreground hover:text-primary transition-colors"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Link>
        </div>

        <SupportTicketDashboard />
      </div>
    </div>
  );
};

export default SupportTickets;